// for required fields please add class .c-form__required
// add class ._send-block for the block which is displayed after sending
// and for elements with formstyler.js plugin add wrapper with .c-form__required_select class
// to enable form validation data-c-form-type = email
// to enable checking phone number data-c-form-type = phone

(function($) {

	jQuery.fn.libriform = function(options){

	// BEGIN plugin options
		options = $.extend({
			url: './report.php',
			parentClass: true,
			singleError: false,
			blockError: true,
			nextBlock: '._send-block',
			callBackSuccess: false,
			callBackError: false,
			errorClass: '-ol-input-wrap_error',
			delegatedSelector: null
		}, options);
	// END plugin options

		var $form = $( this ),

			$inputs = $form.find( '.c-form__required, .c-form__required_select select, .c-form__required_select input' ),
			inputsVal = [],
			regexMail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,10})$/,
			regexPhone = /\b[+]?[-0-9\(\) ]{7,20}\b/,
			error = false,
			submitClick = false;

		$inputs.each( function( index ) {

			inputsVal.push( $( this ).val() );

			$( this ).data( 'index', index );

		});

		var url					= options.url,
			parentClass			= options.parentClass,
			singleError			= options.singleError,
			blockError			= options.blockError,
			nextBlock			= $form.next( options.nextBlock ),
			callBackSuccess		= options.callBackSuccess,
			callBackError		= options.callBackError,
			errorClass			= options.errorClass,
			delegatedSelector	= options.delegatedSelector;

		$inputs.each( function() {

			$( this ).on( 'input', function() {

				if ( submitClick ) {

					unError( $( this ) );
					inputError( this, $( this ).data( 'index' ) );
				}
			});

			$( this ).on( 'change', function() {

				if ( submitClick ) {

					unError( $( this ) );
					inputError( this, $( this ).data( 'index' ) );
				}

			});
		});

		$form.on( 'submit', delegatedSelector, function( e ) {
			submitClick = true;

			unError();

			$inputs.each( function( index, element ) {
				inputError( element, index );
			});

			if ( !error ){ // if there are no errors then send the data
				error = true;

				var str				= $form.serialize(),
					$btn			= $( '.c-form__btn' ),
					btnClassName	= $btn.data( 'c-form-btn-class-active' );

				$btn.addClass( btnClassName );

				$.ajax({
					type: 'POST',
					url: url,
					data: str,
					success: function( data ) {
						$btn.removeClass( btnClassName );

						if ( callBackSuccess && typeof( callBackSuccess ) === 'function' ) {
							callBackSuccess( $form, data );
						}
					},
					error: function( data ) {
						$btn.removeClass( btnClassName );

						if ( callBackError && typeof( callBackError ) === 'function' ) {
							callBackError( $form, data );
						}
					}
				});
			}
			
			return false;
		});

		function unError( $element ) {

			if ( $element ) {

				if ( parentClass ) {

					if ( $element.parent().hasClass( errorClass ) ) {
						$element.parent().removeClass( errorClass );
					} else {
						$element.closest( '.' + errorClass ).removeClass( errorClass );
					}
				} else {

					if ( $element.hasClass( errorClass ) ) {
						$element.removeClass( errorClass );
					} else {
						$element.closest( '.' + errorClass ).removeClass( errorClass );
					}
				}
			} else {

				$form.find( '.' + errorClass ).removeClass( errorClass );
			}

			if ( $form.find( '.error' ).length == 0 ) {

				if ( blockError ) {
					$form.removeClass( 'error' );
				}

				error = false;
			}
		}

		function inputError( element, index ) {

			var $this = $( element );
			// var thisFirstVal = inputsVal[ index ];

			if( $this.is( ':visible' ) ){

				if ( !singleError || ( !error && singleError ) ) {

					if ( $this.get( 0 ).tagName.toLowerCase() == 'input' && ( $this.data( 'c-form-type' ) == 'checkbox' || $this.data( 'c-form-type' ) == 'radio' ) ) {

						if ( !$this.prop( 'checked' ) ) {
							errorActive( $this.closest( '.c-form__required_select' ) );
						}
					}

					if ( !$this.data( 'c-form-type' ) ) {

						if ( !$this.val().trim() ) {

							if ( $this.get( 0 ).tagName.toLowerCase() == 'select' ) {
								errorActive( $this.closest( '.c-form__required_select' ) );
							} else {
								errorActive( $this );
							}
						}
					}

					if ( $this.data( 'c-form-type' ) == 'email' ) {

						if ( !$this.val().trim() || !regexMail.test( $this.val() ) ) {
							errorActive( $this );
						}
					}

					if ( $this.data( 'c-form-type' ) == 'phone' ) {

						if ( !$this.val().trim() || !regexPhone.test( $this.val() ) ) {
							errorActive( $this );
						}
					}
				}
			}
		}

		function errorActive( element ) {

			if ( parentClass ) {
				element.parent().addClass( errorClass );
			} else {
				element.addClass( errorClass );
			}

			if ( blockError ) {
				$form.addClass( 'error' );
			}

			error = true; // determine the index of error
		}

		function getCookie( cname ) { // for Hubspot
			var name = cname + '=',
				decodedCookie = decodeURIComponent( document.cookie ),
				ca = decodedCookie.split( ';' );

			for ( var i = 0; i < ca.length; i++ ) {
				var c = ca[i];
				while ( c.charAt(0) == ' ' ) {
					c = c.substring( 1 );
				}
				if ( c.indexOf( name ) == 0 ) {
					return c.substring( name.length, c.length );
				}
			}
			return '';
		}
	}

})(jQuery);